import React, { useEffect, useRef, useState } from 'react';
import { getToken, setToken } from '../../services/TokenStorage';
import { doRefresh } from '../../services/AuthService';

const WARN_SECONDS = 300;

function decodeExp(token) {
    try {
        const payload = token.split('.')[1];
        const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
        return decoded.exp || 0;
    } catch {
        return 0;
    }
}

function SessionRenewalBanner() {
    const [secondsLeft, setSecondsLeft] = useState(null);
    const [renewing, setRenewing] = useState(false);
    const [renewError, setRenewError] = useState(false);
    const intervalRef = useRef(null);

    function tick() {
        const token = getToken();
        if (!token) { setSecondsLeft(null); return; }
        const exp = decodeExp(token);
        if (!exp) { setSecondsLeft(null); return; }
        const diff = Math.floor(exp - Date.now() / 1000);
        setSecondsLeft(diff > 0 ? diff : 0);
    }

    useEffect(() => {
        tick();
        intervalRef.current = setInterval(tick, 10000);
        return () => clearInterval(intervalRef.current);
    }, []);

    async function onRenew() {
        setRenewing(true);
        setRenewError(false);
        try {
            const result = await doRefresh();
            setToken(result.token);
            tick();
        } catch (_) {
            setRenewError(true);
            tick();
        } finally {
            setRenewing(false);
        }
    }

    if (secondsLeft === null || secondsLeft > WARN_SECONDS) return null;

    const minutes = Math.floor(secondsLeft / 60);
    const secs = secondsLeft % 60;
    const label = secondsLeft === 0
        ? 'Sessão expirada'
        : `Sessão expira em ${minutes}:${String(secs).padStart(2, '0')}`;

    return (
        <li className="nav-item mt-2 px-1">
            <div className="alert alert-warning py-2 px-2 small mb-0">
                <div className="fw-semibold">{label}</div>
                {renewError && (
                    <div className="text-danger small mt-1">Falha ao renovar. Tente novamente.</div>
                )}
                {secondsLeft > 0 && (
                    <button
                        className="btn btn-sm btn-warning mt-1 w-100"
                        onClick={onRenew}
                        disabled={renewing}
                    >
                        {renewing ? 'Renovando...' : 'Renovar sessão'}
                    </button>
                )}
            </div>
        </li>
    );
}

export default SessionRenewalBanner;
